

// import React from 'react';
// import { useDrop } from 'react-dnd';

// // Definir estilos de borde para cada tipo de recurso si no está disponible en otro archivo
// const borderStyles = {
//   entity: { borderColor: '#2d3436' },
//   measurement: { borderColor: '#0984e3' },
//   trigger: { borderColor: '#d63031' },
//   delay: { borderColor: '#fdcb6e' },
//   event: { borderColor: '#00b894' },
//   notification: { borderColor: '#6c5ce7' },
// };

// const WorkflowContainer = ({ onDrop, acceptedTypes, droppedItems, onCardClick, onRemoveItem, isLastItem, selections }) => {
//   const [{ isOver }, drop] = useDrop({
//     accept: acceptedTypes,
//     drop: (item) => onDrop(item),
//     collect: (monitor) => ({
//       isOver: monitor.isOver(),
//     }),
//   });

//   return (
//     <div
//       ref={drop}
//       style={{
//         border: '1px solid black',
//         padding: '20px',
//         minHeight: '100px',
//         maxHeight: '600px',
//         overflowY: 'auto',
//         backgroundColor: isOver ? 'lightblue' : 'white',
//         display: 'flex',
//         flexDirection: 'column',
//         gap: '10px',
//       }}
//     >
//       {droppedItems.map((item, index) => (
//         <div key={index} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
//           <div
//             onClick={() => onCardClick(item)}
//             style={{
//               width: '70%',
//               minWidth: '400px',
//               height: '100px',
//               padding: '15px',
//               borderRadius: '8px',
//               cursor: 'pointer',
//               textAlign: 'center',
//               backgroundColor: '#f8f9fa',
//               border: `2px solid ${selections[item.id] ? 'green' : (borderStyles[item.type]?.borderColor || 'black')}`,
//               boxShadow: selections[item.id] ? '0 0 10px 2px lightgreen' : '0 4px 8px rgba(0,0,0,0.2)',
//               position: 'relative',
//             }}
//           >
//             {selections[item.id] && (
//               <span style={{
//                 position: 'absolute',
//                 top: '5px',
//                 left: '5px',
//                 color: 'green',
//                 fontSize: '20px',
//               }}>✔️</span>
//             )}
//             {item.label}
//             {selections[item.id] && (
//               <div style={{ marginTop: '10px', color: '#555' }}>
//                 Selección: {selections[item.id].visible_name || selections[item.id].name || 'Ninguno'}
//               </div>
//             )}
//             <button
//               onClick={(e) => {
//                 e.stopPropagation();
//                 onRemoveItem(item);
//               }}
//               disabled={!isLastItem(item)}
//               style={{
//                 position: 'absolute',
//                 top: '5px',
//                 right: '5px',
//                 background: 'red',
//                 color: 'white',
//                 border: 'none',
//                 borderRadius: '50%',
//                 width: '20px',
//                 height: '20px',
//                 cursor: isLastItem(item) ? 'pointer' : 'not-allowed',
//                 opacity: isLastItem(item) ? 1 : 0.5,
//               }}
//             >
//               &times;
//             </button>
//           </div>
//           {index < droppedItems.length - 1 && (
//             <div style={{ width: '100%', textAlign: 'center', margin: '5px 0' }}>
//               <span style={{ fontSize: '24px', color: '#333' }}>↓</span>
//             </div>
//           )}
//         </div>
//       ))}
//     </div>
//   );
// };

// export default WorkflowContainer;











import React from 'react';
import { useDrop } from 'react-dnd';

const WorkflowContainer = ({ 
  onDrop, 
  elementsList, 
  acceptedTypes, 
  droppedItems, 
  onCardClick, 
  onRemoveItem, 
  isLastItem, 
  selections,
  orientation
}) => {
  const [{ isOver }, drop] = useDrop({
    accept: acceptedTypes,
    drop: (item) => onDrop(item),
    collect: (monitor) => ({
      isOver: monitor.isOver(),
    }),
  });

  const canvasStyle = {
    width: '100%',
    height: '100%',
    background: isOver ? '#e8f0fe' : '#f8fafc',
    border: isOver ? '2px dashed #1a56db' : '1px solid #e2e8f0',
    borderRadius: '12px',
    padding: '24px',
    display: 'flex',
    flexDirection: orientation === 'vertical' ? 'column' : 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: 0,
    overflow: 'auto',
    transition: 'all 0.2s ease',
    boxSizing: 'border-box',
  };

  if (droppedItems.length === 0) {
    return (
      <div ref={drop} style={canvasStyle}>
        <div style={{
          display: 'flex', flexDirection: 'column',
          alignItems: 'center', justifyContent: 'center',
          width: '100%', height: '100%',
          color: '#94a3b8', fontSize: 13, gap: 10,
          padding: 40,
          textAlign: 'center'
        }}>
          <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M12 5v14" />
            <path d="M5 12h14" />
          </svg>
          <div style={{ fontWeight: 500 }}>Arrastra recursos aquí</div>
          <div style={{ fontSize: 11, color: '#cbd5e1' }}>
            Comienza arrastrando "Dispositivo" o "Grupo" desde el panel izquierdo
          </div>
        </div>
      </div>
    );
  }

  return (
    <div ref={drop} style={canvasStyle}>
      {droppedItems.map((item, index) => (
        <React.Fragment key={index}>
          <div 
            onClick={() => onCardClick(item)}
            style={{
              width: orientation === 'vertical' ? '360px' : '280px',
              minHeight: '84px',
              padding: '18px 22px',
              borderRadius: '10px',
              background: '#ffffff',
              border: '2px solid #10b981',
              boxShadow: '0 0 0 4px rgba(16,185,129,0.15), 0 2px 6px rgba(16,185,129,0.1)',
              position: 'relative',
              cursor: 'pointer',
              transition: 'all 0.15s ease',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 6,
              flexShrink: 0,
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-1px)';
              e.currentTarget.style.boxShadow = '0 0 0 5px rgba(16,185,129,0.2), 0 4px 12px rgba(16,185,129,0.15)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'none';
              e.currentTarget.style.boxShadow = '0 0 0 4px rgba(16,185,129,0.15), 0 2px 6px rgba(16,185,129,0.1)';
            }}
          >
            {/* Pill con tipo de recurso */}
            <span style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 5,
              padding: '3px 10px',
              background: '#d1fae5',
              color: '#059669',
              borderRadius: 999,
              fontSize: 10,
              fontWeight: 600,
              textTransform: 'uppercase',
              letterSpacing: '0.04em',
            }}>
              <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="20 6 9 17 4 12" />
              </svg>
              {item.label}
            </span>

            {/* Nombre del recurso seleccionado */}
            <div style={{
              fontSize: 14,
              fontWeight: 600,
              color: '#0f2d5e',
              textAlign: 'center',
            }}>
              {elementsList[item.id] || '---'}
            </div>

            {/* Botón eliminar (X) */}
            <button
              onClick={(e) => {
                e.stopPropagation();
                onRemoveItem(item);
              }}
              disabled={!isLastItem(item)}
              style={{
                position: 'absolute',
                top: -8,
                right: -8,
                width: 24,
                height: 24,
                borderRadius: '50%',
                background: '#e02424',
                color: '#ffffff',
                border: '2px solid #ffffff',
                cursor: isLastItem(item) ? 'pointer' : 'not-allowed',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 2px 6px rgba(224,36,36,0.3)',
                transition: 'all 0.15s ease',
                padding: 0,
                opacity: isLastItem(item) ? 1 : 0.5,
              }}
              onMouseEnter={(e) => {
                if (isLastItem(item)) {
                  e.currentTarget.style.background = '#b91c1c';
                  e.currentTarget.style.transform = 'scale(1.08)';
                }
              }}
              onMouseLeave={(e) => {
                if (isLastItem(item)) {
                  e.currentTarget.style.background = '#e02424';
                  e.currentTarget.style.transform = 'scale(1)';
                }
              }}
              title="Eliminar paso"
            >
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </button>
          </div>

          {/* Flechas conectoras */}
          {index < droppedItems.length - 1 && (
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: orientation === 'vertical' ? '12px 0' : '0 12px',
              flexShrink: 0,
            }}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#64748b" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                {orientation === 'vertical' ? (
                  <>
                    <line x1="12" y1="5" x2="12" y2="19" />
                    <polyline points="19 12 12 19 5 12" />
                  </>
                ) : (
                  <>
                    <line x1="5" y1="12" x2="19" y2="12" />
                    <polyline points="12 5 19 12 12 19" />
                  </>
                )}
              </svg>
            </div>
          )}
        </React.Fragment>
      ))}
    </div >
  );
};

export default WorkflowContainer;

